import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { hubConnectionReducer } from 'src/app/root-store/hub-connection-store/hub-connection.reducer';
import { hubConnectionFeatureKey } from 'src/app/root-store/hub-connection-store/hub-connection.selectors';
import { HubConnectionEffects } from 'src/app/root-store/hub-connection-store/hub-connections.effects';

export const provideHubConnectionStore = (): EnvironmentProviders[] => [
    provideState(hubConnectionFeatureKey, hubConnectionReducer),
    provideEffects([HubConnectionEffects])
];
